import TreatmentFullLayout from "../../components/TreatmentLayout";

const ErectileDysfunction = () => {

const data = {
title:"Erectile Dysfunction Treatment in Bhilwara",
subtitle:"Advanced men's health treatment at BBMH Hospital",

heading:"Best Erectile Dysfunction Specialist in Bhilwara",
description:"Erectile dysfunction (ED) is a common condition affecting men's sexual health and confidence. At BBMH Hospital Bhilwara, advanced diagnosis and modern treatment options are available to restore normal sexual function and improve quality of life. With 8+ years of urology experience, patients receive confidential and effective care.",

image:"https://cdn-icons-png.flaticon.com/512/4320/4320371.png",

sections:[
{
title:"Symptoms of Erectile Dysfunction",
content:"",
list:[
"Difficulty achieving erection",
"Reduced sexual desire",
"Difficulty maintaining erection",
"Low confidence",
"Relationship stress"
]
},
{
title:"Causes of Erectile Dysfunction",
content:"",
list:[
"Diabetes",
"High blood pressure",
"Stress & anxiety",
"Hormonal imbalance",
"Smoking & alcohol"
]
},
{
title:"Treatment Options",
content:"",
list:[
"Medical therapy",
"Lifestyle modification",
"Hormonal treatment",
"Counselling",
"Advanced therapy"
]
},
{
title:"Why Choose BBMH Hospital?",
content:"",
list:[
"Experienced urologist",
"Confidential consultation",
"Advanced treatment",
"Affordable care",
"High success results"
]
}
],

faq:[
{q:"Is erectile dysfunction curable?",a:"Yes, most cases are treatable."},
{q:"Is treatment safe?",a:"Yes completely safe under expert doctor."},
{q:"Do I need tests?",a:"Basic tests help identify cause."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default ErectileDysfunction;
